
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("1VYG6", function(module, exports) {
/**
 * @Relay no-runtime
 */ /**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $xQxzY = parcelRequire("xQxzY");


var $gWF6I = parcelRequire("gWF6I");


var $1o4fX = parcelRequire("1o4fX");


var $euL71 = parcelRequire("euL71");


var $ivb8S = parcelRequire("ivb8S");


var $bQm3c = parcelRequire("bQm3c");


var $1ytiN = parcelRequire("1ytiN");


var $irVI7 = parcelRequire("irVI7");


var $a1uvs = parcelRequire("a1uvs");

var $gfIPU = parcelRequire("gfIPU");

var $1eaCJ = parcelRequire("1eaCJ");

var $1kHsc = parcelRequire("1kHsc");


var $7Sm4c = parcelRequire("7Sm4c");


var $1uFM6 = parcelRequire("1uFM6");


var $bFDX4 = parcelRequire("bFDX4");


var $9wGTI = parcelRequire("9wGTI");


var $6eN5W = parcelRequire("6eN5W");


var $iuUMQ = parcelRequire("iuUMQ");


var $gqp7m = parcelRequire("gqp7m");


var $cFEpk = parcelRequire("cFEpk");


var $922yL = parcelRequire("922yL");

const $0b082f0088987b79$var$GRACE_PERIOD = 14; // days after trial ends for both HAMS and CCP
const $0b082f0088987b79$export$ede2048f0629c2b6 = (queryData)=>{
    const trialEndDateString = queryData?.license?.trialEndDate;
    // When the customer starts an instance, the exact timestamp of the trial end is not
    // recorded. We made the decision to always return the UTC date for `trialEndDate`.
    const trialEndDate = trialEndDateString ? new Date(trialEndDateString) : null;
    if (!trialEndDate || !(0, $cFEpk.default)(new Date(trialEndDate))) return null;
    const deactivationDate = (0, $922yL.default)(trialEndDate, $0b082f0088987b79$var$GRACE_PERIOD);
    return {
        deactivationDate: deactivationDate,
        trialEndDate: trialEndDate
    };
};



var $8JJsY = parcelRequire("8JJsY");


var $53KZp = parcelRequire("53KZp");


var $7XaXR = parcelRequire("7XaXR");


var $hY10E = parcelRequire("hY10E");

/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $298fe7d1fa52d113$export$2c393978d59015b8 = /*#__PURE__*/ function(BillingSourceSystem) {
    BillingSourceSystem["CCP"] = "CCP";
    BillingSourceSystem["HAMS"] = "HAMS";
    return BillingSourceSystem;
}({});



var $5lbXZ = parcelRequire("5lbXZ");


var $iTy4g = parcelRequire("iTy4g");

/* TrialFlagsComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");


var $T1bCI = parcelRequire("T1bCI");


var $inPa6 = parcelRequire("inPa6");


var $gdv5Z = parcelRequire("gdv5Z");

var $iXCQx = parcelRequire("iXCQx");


var $4LS1B = parcelRequire("4LS1B");





var $gqqjz = parcelRequire("gqqjz");





var $cN2XO = parcelRequire("cN2XO");




const $23ca7e64a5767c43$var$FREE_USER_LIMIT = 10;
const $23ca7e64a5767c43$var$linkStyles = {
    modalTakeAction: "_syaz13af _1bnx8stv _d0altlke"
};
const $23ca7e64a5767c43$var$i18n = (0, $cgtv4.defineMessages)({
    titlePremium: {
        id: "trial-components.flag.title.premium",
        defaultMessage: "Your Premium trial ends in {trialDaysLeft, plural, one {# day} other {# days}}"
    },
    titleStandard: {
        id: "trial-components.flag.title.standard",
        defaultMessage: "Your Standard trial ends in {trialDaysLeft, plural, one {# day} other {# days}}"
    },
    removeUsersLinkText: {
        id: "trial-components.flag.remove-users.link-text",
        defaultMessage: "Remove users"
    },
    choosePlanLinkText: {
        id: "trial-components.flag.choose-plan.link-text",
        defaultMessage: "Choose plan"
    },
    infoDescription: {
        id: "trial-components.flag.info.description",
        defaultMessage: "Add payment details to stay on {edition} and keep the features you love. Otherwise, your site will be downgraded to Confluence Free."
    },
    warningDescription: {
        id: "trial-components.flag.warning.description",
        defaultMessage: "Add payment details to stay on {edition} and keep more than 10 users, or remove users and switch to Confluence Free. <strong>If you don\u2019t take action, your site will be deactivated on {deactivationDateLong}.</strong>"
    },
    addPaymentDetailsCTA: {
        id: "trial-components.flag.add-payment-details",
        defaultMessage: "Add payment details"
    },
    reverseTrialsTitleOverUserLimit3DaysLeft: {
        id: "trial-components.flag.rt-title.overUserLimit.three-days-left",
        defaultMessage: "Choose a plan to avoid deactivation"
    },
    reverseTrialsTitleOverUserLimit1DaysLeft: {
        id: "trial-components.flag.rt-title.overUserLimit.one-day-left",
        defaultMessage: "Choose a plan to avoid deactivation"
    },
    reverseTrialsTitleUnderUserLimit3DaysLeft: {
        id: "trial-components.flag.rt-title.underUserLimit.three-days-left",
        defaultMessage: "Final stretch! Your trial ends in {trialDaysLeft, plural, one {# day} other {# days}}"
    },
    reverseTrialsTitleUnderUserLimit1DaysLeft: {
        id: "trial-components.flag.rt-title.underUserLimit.one-day-left",
        defaultMessage: "Time\u2019s almost up! Your trial ends in {trialDaysLeft, plural, one {# day} other {# days}}"
    },
    reverseTrialsDescriptionOverUserLimit3DaysLeft: {
        id: "trial-components.flag.rt-description.overUserLimit.three-days-left",
        defaultMessage: "You have more than {freeUserLimit} users, so you\u2019ll need to choose a paid plan or remove users by {deactivationDateLong}."
    },
    reverseTrialsDescriptionOverUserLimit1DaysLeft: {
        id: "trial-components.flag.rt-description.overUserLimit.one-day-left",
        defaultMessage: "You have more than {freeUserLimit} users, so you\u2019ll need to choose a paid plan or remove users by {deactivationDateLong}."
    },
    reverseTrialsDescriptionUnderUserLimit3DaysLeft: {
        id: "trial-components.flag.rt-description.underUserLimit.three-days-left",
        defaultMessage: "See pricing and choose a plan, or you\u2019ll be downgraded to a free plan with limited features."
    },
    reverseTrialsDescriptionUnderUserLimit1DaysLeft: {
        id: "trial-components.flag.rt-description.underUserLimit.one-day-left",
        defaultMessage: "See pricing and choose a plan, or you\u2019ll be downgraded to a free plan with limited features."
    },
    autoUpgradeTitleLastDayOfPredunning: {
        id: "trial-components.flag.auto-upgrade.title-last-day-of-predunning",
        defaultMessage: "Take action, avoid deactivation"
    },
    autoUpgradeTitleWithDaysLeft: {
        id: "trial-components.flag.auto-upgrade.title-with-days-left",
        // eslint-disable-next-line @atlassian/i18n/enforce-plural-rules
        defaultMessage: "{trialDaysLeft, plural, =1 {# day} other {# days}} left to avoid deactivation"
    },
    autoUpgradeDescription: {
        id: "trial-components.flag.auto-upgrade.description",
        defaultMessage: "Add payment or remove users by {deactivationDate} to avoid site deactivation."
    },
    takeActionCTA: {
        id: "trial-components.flag.auto-upgrade.take-action",
        defaultMessage: "Take action"
    }
});
const $23ca7e64a5767c43$var$LINK_TO_REMOVE_USERS = 'https://support.atlassian.com/confluence-cloud/docs/removing-users-and-downgrading-to-confluence-free/';
const $23ca7e64a5767c43$var$USER_ACTION_REMOVE_USER = 'removeUser';
const $23ca7e64a5767c43$var$USER_ACTION_ADD_BILLING = 'addBilling';
const $23ca7e64a5767c43$var$USER_ACTION_CHOOSE_PLAN = 'choosePlan';
const $23ca7e64a5767c43$var$USER_ACTION_OPEN_AUTO_UPGRADE_DEACTIVATION_MODAL = 'openAutoUpgradeDeactivationModal';
const $23ca7e64a5767c43$var$getActionAnalyticsEvent = (edition, type, userAction, autoUpgradeNotATrialExperimentCohort, trialDaysLeft, daysLeftInPredunning, premiumReverseTrialABCohort)=>({
        type: 'sendUIEvent',
        data: {
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'trialActionComponent',
            attributes: {
                edition: edition,
                trialDaysLeft: trialDaysLeft,
                daysLeftInPredunning: daysLeftInPredunning,
                userAction: userAction,
                type: type,
                premiumReverseTrialABCohort: premiumReverseTrialABCohort,
                autoUpgradeNotATrialExperimentCohort: autoUpgradeNotATrialExperimentCohort
            },
            source: 'trialFlag'
        }
    });
const $23ca7e64a5767c43$var$TrialFlagsComponentInner = ({ daysLeftInPredunning: daysLeftInPredunning, deactivationDate: deactivationDate, edition: edition, flags: flags, licenseConsumingUserCount: licenseConsumingUserCount, linkToAddBilling: linkToAddBilling, cloudId: cloudId, onDismiss: onDismissStoreFlagOnboardingState, trialDaysLeft: trialDaysLeft, isEligibleForPremiumReverseTrialsExperiment: isEligibleForPremiumReverseTrialsExperiment, planSelectionPageUrl: planSelectionPageUrl, autoUpgradeNotATrialExperimentCohort: autoUpgradeNotATrialExperimentCohort })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { orgId: orgId, environment: environment } = (0, $bQm3c.useSessionData)();
    const isWarn = licenseConsumingUserCount > 10;
    const type = isWarn ? 'warning' : 'info';
    let flagId = `${edition}-trial-${trialDaysLeft}-day-${type}-flag`;
    const premiumReverseTrialABCohort = (0, $7XaXR.usePremiumReverseTrialABCohort)({
        isEligible: isEligibleForPremiumReverseTrialsExperiment,
        touchpointId: 'trial-flag',
        attributes: {
            planSelectionPageUrl: planSelectionPageUrl,
            trialDaysLeft: trialDaysLeft,
            deactivationDate: deactivationDate?.toISOString(),
            licenseConsumingUserCount: licenseConsumingUserCount
        }
    });
    const hasShownFlagRef = (0, $42omo.useRef)(false);
    const flagIdRef = (0, $42omo.useRef)(null);
    const hasFiredAnalyticsRef = (0, $42omo.useRef)(false);
    const onDismiss = (0, $42omo.useCallback)(()=>{
        flagIdRef.current && flags.hideFlag(flagIdRef.current);
        onDismissStoreFlagOnboardingState();
    }, [
        flags,
        onDismissStoreFlagOnboardingState
    ]);
    const handleAddBillingClick = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent($23ca7e64a5767c43$var$getActionAnalyticsEvent(edition, type, $23ca7e64a5767c43$var$USER_ACTION_ADD_BILLING, autoUpgradeNotATrialExperimentCohort, trialDaysLeft, daysLeftInPredunning, premiumReverseTrialABCohort)).fire();
    }, [
        edition,
        trialDaysLeft,
        type,
        createAnalyticsEvent,
        premiumReverseTrialABCohort,
        autoUpgradeNotATrialExperimentCohort,
        daysLeftInPredunning
    ]);
    const handleRemoveUsersClick = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent($23ca7e64a5767c43$var$getActionAnalyticsEvent(edition, type, $23ca7e64a5767c43$var$USER_ACTION_REMOVE_USER, autoUpgradeNotATrialExperimentCohort, trialDaysLeft, daysLeftInPredunning, premiumReverseTrialABCohort)).fire();
    }, [
        edition,
        trialDaysLeft,
        type,
        createAnalyticsEvent,
        premiumReverseTrialABCohort,
        autoUpgradeNotATrialExperimentCohort,
        daysLeftInPredunning
    ]);
    const handleChoosePlanClick = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent($23ca7e64a5767c43$var$getActionAnalyticsEvent(edition, type, $23ca7e64a5767c43$var$USER_ACTION_CHOOSE_PLAN, autoUpgradeNotATrialExperimentCohort, trialDaysLeft, daysLeftInPredunning, premiumReverseTrialABCohort)).fire();
    }, [
        edition,
        trialDaysLeft,
        type,
        createAnalyticsEvent,
        premiumReverseTrialABCohort,
        autoUpgradeNotATrialExperimentCohort,
        daysLeftInPredunning
    ]);
    const handleTakeActionClick = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent($23ca7e64a5767c43$var$getActionAnalyticsEvent(edition, type, $23ca7e64a5767c43$var$USER_ACTION_OPEN_AUTO_UPGRADE_DEACTIVATION_MODAL, autoUpgradeNotATrialExperimentCohort, trialDaysLeft, daysLeftInPredunning, premiumReverseTrialABCohort)).fire();
    }, [
        edition,
        trialDaysLeft,
        type,
        createAnalyticsEvent,
        premiumReverseTrialABCohort,
        autoUpgradeNotATrialExperimentCohort,
        daysLeftInPredunning
    ]);
    const addPaymentDetails = {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $23ca7e64a5767c43$var$i18n.addPaymentDetailsCTA),
        href: linkToAddBilling,
        target: '_blank',
        onClick: handleAddBillingClick
    };
    const removeUsersAction = {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $23ca7e64a5767c43$var$i18n.removeUsersLinkText),
        href: $23ca7e64a5767c43$var$LINK_TO_REMOVE_USERS,
        target: '_blank',
        onClick: handleRemoveUsersClick
    };
    const removeUsersNavigateToOrgInAdminHub = {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $23ca7e64a5767c43$var$i18n.removeUsersLinkText),
        href: (0, $cN2XO.linkToAdminHubOrg)(environment, orgId, '/users?status=ACTIVE'),
        target: '_blank',
        onClick: handleRemoveUsersClick
    };
    const choosePlanLink = {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $23ca7e64a5767c43$var$i18n.choosePlanLinkText),
        href: planSelectionPageUrl,
        target: '_blank',
        onClick: handleChoosePlanClick
    };
    const autoUpgradeTakeActionContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4LS1B.AutoUpgradeAvoidDeactivationModal), {
        product: "confluence",
        touchpointId: "avoid-deactivation-flag",
        cloudId: cloudId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        as: "span",
        xcss: $23ca7e64a5767c43$var$linkStyles.modalTakeAction,
        testId: "auto-upgrade-avoid-deactivation-flag-take-action-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $23ca7e64a5767c43$var$i18n.takeActionCTA)));
    const autoUpgradeTakeAction = {
        content: autoUpgradeTakeActionContent,
        onClick: handleTakeActionClick
    };
    const editionKey = edition === (0, $euL71.ConfluenceEdition).STANDARD ? 'Standard' : 'Premium';
    let flag = null;
    if (premiumReverseTrialABCohort === 'variation' && deactivationDate !== undefined) {
        const userLimitDescriptor = licenseConsumingUserCount > $23ca7e64a5767c43$var$FREE_USER_LIMIT ? 'Over' : 'Under';
        const rtTitle = `reverseTrialsTitle${userLimitDescriptor}UserLimit${trialDaysLeft}DaysLeft`;
        const rtDescription = `reverseTrialsDescription${userLimitDescriptor}UserLimit${trialDaysLeft}DaysLeft`;
        flagId = `${flagId}-reverse-trial`;
        flag = {
            id: flagId,
            type: type,
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
                ...$23ca7e64a5767c43$var$i18n[rtTitle],
                values: {
                    trialDaysLeft: trialDaysLeft
                }
            }),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
                ...$23ca7e64a5767c43$var$i18n[rtDescription],
                values: isWarn ? {
                    deactivationDateLong: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cgtv4.FormattedDate), {
                        value: deactivationDate,
                        month: "long",
                        day: "numeric"
                    }),
                    freeUserLimit: $23ca7e64a5767c43$var$FREE_USER_LIMIT
                } : {}
            }),
            actions: isWarn ? [
                choosePlanLink,
                removeUsersNavigateToOrgInAdminHub
            ] : [
                choosePlanLink
            ],
            onClose: onDismiss
        };
    } else if (autoUpgradeNotATrialExperimentCohort === 'treatment' && deactivationDate !== undefined && daysLeftInPredunning !== undefined) {
        const title = daysLeftInPredunning === 0 ? $23ca7e64a5767c43$var$i18n.autoUpgradeTitleLastDayOfPredunning : $23ca7e64a5767c43$var$i18n.autoUpgradeTitleWithDaysLeft;
        flag = {
            id: flagId,
            type: 'warning',
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
                ...title,
                values: {
                    trialDaysLeft: daysLeftInPredunning
                }
            }),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
                ...$23ca7e64a5767c43$var$i18n.autoUpgradeDescription,
                values: {
                    deactivationDate: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
                        weight: "bold"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cgtv4.FormattedDate), {
                        value: deactivationDate,
                        month: "long",
                        day: "numeric"
                    }))
                }
            }),
            actions: [
                autoUpgradeTakeAction
            ],
            onClose: onDismiss
        };
    } else if (premiumReverseTrialABCohort !== undefined) flag = {
        id: flagId,
        type: type,
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
            ...$23ca7e64a5767c43$var$i18n[`title${editionKey}`],
            values: {
                trialDaysLeft: trialDaysLeft
            }
        }),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
            ...$23ca7e64a5767c43$var$i18n[`${type}Description`],
            values: isWarn ? {
                deactivationDateLong: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cgtv4.FormattedDate), {
                    value: deactivationDate,
                    month: "long",
                    day: "numeric"
                }),
                strong: (...chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
                        as: "strong"
                    }, chunks),
                edition: editionKey
            } : {
                edition: editionKey
            }
        }),
        actions: isWarn ? [
            addPaymentDetails,
            removeUsersAction
        ] : [
            addPaymentDetails
        ],
        onClose: onDismiss
    };
    flagIdRef.current = flagId;
    if (hasShownFlagRef && !hasShownFlagRef.current && flag) {
        flags.showFlag(flag).then((newFlag)=>{
            // If a new flag was created, store the new flag's ID so we can update it.  Note that
            // `showFlag()` only asynchronously returns a valid newFlag if it created a new flag;
            // if it found an existing flag with the specified ID then it asynchronously returns
            // nothing (undefined).
            if (newFlag) flagIdRef.current = newFlag.id;
        });
        hasShownFlagRef.current = true;
    }
    if (!hasFiredAnalyticsRef.current && flag) {
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'trialFlagScreen',
                attributes: {
                    edition: edition,
                    trialDaysLeft: trialDaysLeft,
                    daysLeftInPredunning: daysLeftInPredunning,
                    type: type,
                    premiumReverseTrialABCohort: premiumReverseTrialABCohort,
                    autoUpgradeNotATrialExperimentCohort: autoUpgradeNotATrialExperimentCohort
                }
            }
        }).fire(); // Mark the event as fired
        hasFiredAnalyticsRef.current = true;
    }
    return null;
};
const $23ca7e64a5767c43$export$a104e87722fbc3f2 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $gqqjz.FlagsStateContainer)
        ]
    }, (flags)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($23ca7e64a5767c43$var$TrialFlagsComponentInner, {
            flags: flags,
            ...props
        });
    });
};


const $b12f361e855fedcd$var$DAYS_LEFT_IN_TRIAL_TO_SHOW_FLAGS = [
    1,
    3
];
const $b12f361e855fedcd$var$DAYS_LEFT_IN_PRE_DUNNING_TO_SHOW_FLAGS_AUTO_UPGRADE_NOT_A_TRIAL_EXPERIMENT = [
    3,
    2,
    1,
    -0
];
const $b12f361e855fedcd$var$mapDismissStateKeyInTrial = (daysLeft)=>daysLeft ? `dismissedTrial${daysLeft}DayFlag` : '';
const $b12f361e855fedcd$var$mapDismissStateKeyInPredunning = (daysLeft)=>daysLeft ? `dismissedPredunning${daysLeft}DayFlag` : '';
const $b12f361e855fedcd$export$c108f21945b8b79 = ()=>{
    const { isLicensed: isLicensed, isLoggedIn: isLoggedIn, userId: userId, edition: edition, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { isSiteAdmin: isSiteAdmin } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const hasExperienceTrackerStartedRef = (0, $42omo.useRef)(false);
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const isTrialEdition = edition === (0, $euL71.ConfluenceEdition).STANDARD || edition === (0, $euL71.ConfluenceEdition).PREMIUM;
    const skipTrialDetailsQuery = !isLicensed || !isLoggedIn || !isSiteAdmin || !userId || !isTrialEdition;
    const { data: trialDetailsData, loading: trialLoading, error: trialError } = (0, $xQxzY.useQuery)((0, $eSUdr.default)`query TrialFlagsTrialDetailsQuery{license{billingSourceSystem licenseConsumingUserCount trialEndDate}}`, {
        skip: skipTrialDetailsQuery
    });
    const licenseConsumingUserCount = (0, $iuUMQ.getLicenseConsumingUserCountFromQuery)(trialDetailsData);
    const billingSourceSystem = trialDetailsData?.license?.billingSourceSystem;
    const trialEndDate = trialDetailsData?.license?.trialEndDate;
    const formattedDate = (0, $0b082f0088987b79$export$ede2048f0629c2b6)(trialDetailsData);
    const { deactivationDate: deactivationDateTrial } = formattedDate || {};
    const trialDaysLeft = (0, $1o4fX.getTrialDaysLeftFromTrialEndDate)(trialEndDate) ?? null;
    const isInTrial = !!trialEndDate && trialDaysLeft && trialDaysLeft >= 0;
    const skipPredunningQuery = skipTrialDetailsQuery || isInTrial || billingSourceSystem !== (0, $298fe7d1fa52d113$export$2c393978d59015b8).CCP;
    const { deactivationDate: preDunningDeactivationDateResult, isPreDunningPeriod: isPreDunningPeriod, errorSource: predunningErrorSource, loading: predunningLoading, error: predunningError } = (0, $iTy4g.useIsPreDunningPeriod)({
        skip: skipPredunningQuery
    });
    const { daysLeftUntilDeactivation: daysLeftUntilDeactivation, date: deactivationDatePreDunning } = preDunningDeactivationDateResult || {};
    const isInTrialOrPredunning = isInTrial || isPreDunningPeriod;
    const isValidTrialDayToShowFlag = !!trialDaysLeft && $b12f361e855fedcd$var$DAYS_LEFT_IN_TRIAL_TO_SHOW_FLAGS.includes(trialDaysLeft);
    const isValidPredunningDayToShowFlag = isPreDunningPeriod && daysLeftUntilDeactivation !== undefined && $b12f361e855fedcd$var$DAYS_LEFT_IN_PRE_DUNNING_TO_SHOW_FLAGS_AUTO_UPGRADE_NOT_A_TRIAL_EXPERIMENT.includes(daysLeftUntilDeactivation) && (0, $9wGTI.fg)('auto_upgrade_not_a_trial_experiment_connie_gate');
    const dismissedFlagKey = isPreDunningPeriod ? $b12f361e855fedcd$var$mapDismissStateKeyInPredunning(daysLeftUntilDeactivation) : $b12f361e855fedcd$var$mapDismissStateKeyInTrial(trialDaysLeft);
    let onboardingFlagKey;
    if (trialDaysLeft === 1) onboardingFlagKey = (0, $6eN5W.TRIAL_COMPONENTS_EXPERIENCES).TRIAL_1_DAY_FLAG_DISMISSED;
    else if (trialDaysLeft === 3) onboardingFlagKey = (0, $6eN5W.TRIAL_COMPONENTS_EXPERIENCES).TRIAL_3_DAY_FLAG_DISMISSED;
    else if (daysLeftUntilDeactivation === 3) onboardingFlagKey = (0, $6eN5W.TRIAL_COMPONENTS_EXPERIENCES).GRACE_PERIOD_3_DAY_FLAG_DISMISSED;
    else if (daysLeftUntilDeactivation === 2) onboardingFlagKey = (0, $6eN5W.TRIAL_COMPONENTS_EXPERIENCES).GRACE_PERIOD_2_DAY_FLAG_DISMISSED;
    else if (daysLeftUntilDeactivation === 1) onboardingFlagKey = (0, $6eN5W.TRIAL_COMPONENTS_EXPERIENCES).GRACE_PERIOD_1_DAY_FLAG_DISMISSED;
    else if (daysLeftUntilDeactivation === 0) onboardingFlagKey = (0, $6eN5W.TRIAL_COMPONENTS_EXPERIENCES).GRACE_PERIOD_0_DAY_FLAG_DISMISSED;
    else // This shouldn't actually get used since the query will be skipped and the
    // component will return null. We just need to make sure we're passing a valid
    // key to the `useGetOnboardingState` hook.
    onboardingFlagKey = (0, $6eN5W.TRIAL_COMPONENTS_EXPERIENCES).TRIAL_UNHANDLED_DAY_FLAG_DISMISSED;
    const skipCommerceQueries = !(isValidTrialDayToShowFlag || isValidPredunningDayToShowFlag);
    const { hasBillingInformation: hasBillingInformation, loading: billingLoading, error: billingErr } = (0, $gqp7m.useHasBillingInformation)(skipCommerceQueries);
    const skipGetOnboardingStateQuery = skipCommerceQueries || hasBillingInformation;
    const { data: onboardingStateData, loading: onboardingStateLoading, error: onboardingStateErr } = (0, $ivb8S.useGetOnboardingState)(onboardingFlagKey, skipGetOnboardingStateQuery);
    const data = (0, $ivb8S.deserializeState)(onboardingStateData);
    const hasDismissedFlag = data[dismissedFlagKey];
    const { loading: useAutoUpgradeNotATrialExperimentLoading, error: useAutoUpgradeNotATrialExperimentError, autoUpgradeNotATrialExperimentCohort: autoUpgradeNotATrialExperimentCohort } = (0, $5lbXZ.useAutoUpgradeNotATrialExperiment)({
        isSiteAdmin: isSiteAdmin,
        edition: edition,
        hasBillingInformation: hasBillingInformation,
        commerceBackendName: billingSourceSystem,
        isInTrialOrPredunning: isInTrialOrPredunning,
        source: 'confluence_trial_flag',
        analyticAttributes: {
            trialDaysLeft: trialDaysLeft
        },
        skip: !(0, $9wGTI.fg)('auto_upgrade_not_a_trial_experiment_connie_gate') || !(isValidPredunningDayToShowFlag || isValidTrialDayToShowFlag)
    });
    const shouldSkipPremiumReverseTrialsCheck = skipCommerceQueries || edition !== (0, $euL71.ConfluenceEdition).PREMIUM || hasBillingInformation || !(0, $9wGTI.fg)('growth_confluence_buy_reverse_trials_fg');
    const { isReverseTrialer: isReverseTrialer, loading: isReverseTrialLoading, error: isReverseTrialerError } = (0, $hY10E.useReverseTrialCohort)({
        skip: shouldSkipPremiumReverseTrialsCheck
    });
    const { isAvailableToUser: isPlanSelectionPageUrlAvailable, planSelectionPageUrl: planSelectionPageUrl, error: pspUrlError, loading: isPSPUrlLoading } = (0, $53KZp.usePlanSelectionPageInfo)({
        skip: shouldSkipPremiumReverseTrialsCheck
    });
    const isEligibleForPremiumReverseTrialsExperiment = (0, $7XaXR.useIsEligibleForPremiumReverseTrialsExperiment)({
        isReverseTrialer: isReverseTrialer,
        isInTrial: (trialDaysLeft ?? 0) > 0,
        edition: edition,
        hasBillingInformation: hasBillingInformation,
        commerceBackendName: billingSourceSystem,
        isPlanSelectionPageUrlAvailable: isPlanSelectionPageUrlAvailable
    });
    const { paymentFlowUrl: paymentFlowUrl, loading: urlLoading, error: urlErr } = (0, $8JJsY.useBillingUrls)(skipCommerceQueries || autoUpgradeNotATrialExperimentCohort === 'treatment');
    const onDismissFlag = (0, $42omo.useCallback)(()=>{
        if (!hasDismissedFlag) setOnboardingState({
            key: onboardingFlagKey,
            value: 'true'
        });
    }, [
        onboardingFlagKey,
        hasDismissedFlag,
        setOnboardingState
    ]);
    const canTrackExperience = !skipTrialDetailsQuery && !skipCommerceQueries && !skipGetOnboardingStateQuery;
    if (!hasExperienceTrackerStartedRef.current && canTrackExperience) {
        experienceTracker.start({
            name: (0, $irVI7.TRIAL_COMPONENTS_FLAG_VIEW_EXPERIENCE)
        });
        hasExperienceTrackerStartedRef.current = true;
    }
    const loading = trialLoading || urlLoading || billingLoading || onboardingStateLoading || isReverseTrialLoading || isPSPUrlLoading || useAutoUpgradeNotATrialExperimentLoading || predunningLoading;
    // `TrialDetailsQuery` can throw Permission exception if initiater doesn't have sufficient permission
    // Permission error in this case is expected and FE should handle it gracefully - "markErrorAsHandled" and abort the experience instead of reporting as failures.
    if (trialError && (0, $1uFM6.isUnauthorizedError)(trialError)) {
        (0, $7Sm4c.markErrorAsHandled)(trialError);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a1uvs.ExperienceAbort), {
            name: (0, $irVI7.TRIAL_COMPONENTS_FLAG_VIEW_EXPERIENCE),
            reason: "Aborted due to insufficient permission"
        });
    }
    // `useHasBillingInformation` can cause a rate limiting error
    if (billingErr && (0, $bFDX4.isTooManyRequestsError)(billingErr)) {
        (0, $7Sm4c.markErrorAsHandled)(billingErr);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a1uvs.ExperienceAbort), {
            name: (0, $irVI7.TRIAL_COMPONENTS_FLAG_VIEW_EXPERIENCE),
            reason: "Aborted due to rate limit exceeded error"
        });
    }
    const error = trialError || urlErr || billingErr || onboardingStateErr || pspUrlError || isReverseTrialerError || useAutoUpgradeNotATrialExperimentError || predunningError;
    const shouldShowFlag = autoUpgradeNotATrialExperimentCohort === 'treatment' ? isValidPredunningDayToShowFlag : isValidTrialDayToShowFlag;
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gfIPU.ExperienceFailure), {
        name: (0, $irVI7.TRIAL_COMPONENTS_FLAG_VIEW_EXPERIENCE),
        error: error,
        attributes: {
            trialErr: trialError?.message,
            urlErr: urlErr?.message,
            billingErr: billingErr?.message,
            onboardingStateErr: onboardingStateErr?.message,
            pspUrlError: pspUrlError?.message,
            isReverseTrialerError: isReverseTrialerError?.message,
            useAutoUpgradeNotATrialExperimentError: useAutoUpgradeNotATrialExperimentError?.message,
            predunningError: predunningError?.message,
            predunningErrorSource: predunningErrorSource
        }
    });
    if (loading) return null;
    if (skipGetOnboardingStateQuery || !onboardingStateData || !shouldShowFlag || hasDismissedFlag || !isTrialEdition) {
        experienceTracker.abort({
            name: (0, $irVI7.TRIAL_COMPONENTS_FLAG_VIEW_EXPERIENCE),
            reason: 'Aborted because a pre-requisite was not met'
        });
        return null;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gWF6I.RelayEnvironmentProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $23ca7e64a5767c43$export$a104e87722fbc3f2), {
        edition: edition,
        daysLeftInPredunning: daysLeftUntilDeactivation,
        deactivationDate: deactivationDateTrial || deactivationDatePreDunning,
        licenseConsumingUserCount: licenseConsumingUserCount,
        linkToAddBilling: paymentFlowUrl,
        trialDaysLeft: trialDaysLeft,
        cloudId: cloudId,
        onDismiss: onDismissFlag,
        isEligibleForPremiumReverseTrialsExperiment: isEligibleForPremiumReverseTrialsExperiment,
        planSelectionPageUrl: planSelectionPageUrl,
        autoUpgradeNotATrialExperimentCohort: autoUpgradeNotATrialExperimentCohort
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
        name: (0, $irVI7.TRIAL_COMPONENTS_FLAG_VIEW_EXPERIENCE),
        attributes: {
            autoUpgradeNotATrialExperimentCohort: autoUpgradeNotATrialExperimentCohort,
            daysLeftUntilDeactivation: daysLeftUntilDeactivation,
            trialDaysLeft: trialDaysLeft
        }
    }));
};
module.exports["TrialFlags"] = $b12f361e855fedcd$export$c108f21945b8b79;

});

parcelRegister("a1uvs", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $1kHsc = parcelRequire("1kHsc");

function $5da8a4a03d184e93$export$c9b6bcd70239a39c(t0) {
    const $ = (0, $frIzR.c)(5);
    const { name: name, reason: reason } = t0;
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t1;
    let t2;
    if ($[0] !== experienceTracker || $[1] !== name || $[2] !== reason) {
        t1 = ()=>experienceTracker.abort({
                name: name,
                reason: reason
            });
        t2 = [
            name,
            reason,
            experienceTracker
        ];
        $[0] = experienceTracker;
        $[1] = name;
        $[2] = reason;
        $[3] = t1;
        $[4] = t2;
    } else {
        t1 = $[3];
        t2 = $[4];
    }
    (0, $42omo.useEffect)(t1, t2);
    return null;
}
module.exports["ExperienceAbort"] = $5da8a4a03d184e93$export$c9b6bcd70239a39c;

});

parcelRegister("bFDX4", function(module, exports) {

var $aMcHK = parcelRequire("aMcHK");

const $8182af0d2f396edd$export$5df30e64c619846d = (error)=>(0, $aMcHK.isStatusCodeError)(error, '429');
module.exports["isTooManyRequestsError"] = $8182af0d2f396edd$export$5df30e64c619846d;

});

parcelRegister("gqp7m", function(module, exports) {
/**
 * @Relay no-runtime
 */ /**
 * @graphql agg
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $xQxzY = parcelRequire("xQxzY");


var $bQm3c = parcelRequire("bQm3c");


var $1ytiN = parcelRequire("1ytiN");


var $gKr8t = parcelRequire("gKr8t");


var $7Sm4c = parcelRequire("7Sm4c");


var $1uFM6 = parcelRequire("1uFM6");


var $f9jv7 = parcelRequire("f9jv7");


var $bFDX4 = parcelRequire("bFDX4");

const $211f773a291d5685$export$b4b101074ba9b8a2 = (skip = false)=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { isSiteAdmin: isSiteAdmin } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const shouldSkip = skip || !isSiteAdmin || !cloudId;
    const { data: data, loading: loading, error: queryError } = (0, $xQxzY.useQuery)((0, $eSUdr.default)`query useHasBillingInformationIsAccountInvoiceableQuery($cloudId:ID!$hamsProductKey:String!){tenantContexts(cloudIds:[$cloudId]){entitlementInfo(hamsProductKey:$hamsProductKey){...on CommerceEntitlementInfoCcp{entitlementId entitlement{...on CcpEntitlement{id subscription{...on CcpSubscription{id accountDetails{invoiceGroup{invoiceable id}}}}}}}}}}`, {
        variables: {
            cloudId: cloudId,
            hamsProductKey: 'confluence.ondemand'
        },
        skip: shouldSkip,
        client: (0, $gKr8t.getAGGClient)()
    });
    if (shouldSkip) return {
        hasBillingInformation: false,
        loading: false,
        error: null
    };
    let hasBillingInformation = false;
    let error = queryError || null;
    if (!loading) {
        if (queryError) // unauthorized, not found, too many requests errors are expected
        {
            if ((0, $1uFM6.isUnauthorizedError)(queryError) || (0, $f9jv7.isNotFoundError)(queryError) || (0, $bFDX4.isTooManyRequestsError)(queryError) || $211f773a291d5685$var$isGraphQLTooManyRequestsError(queryError)) {
                (0, $7Sm4c.markErrorAsHandled)(queryError);
                error = null;
            }
        } else hasBillingInformation = data?.tenantContexts?.[0]?.entitlementInfo?.entitlement?.subscription?.accountDetails?.invoiceGroup?.invoiceable ?? false;
    }
    return {
        hasBillingInformation: hasBillingInformation,
        loading: loading,
        error: error
    };
};
/**
 * Checks if the provided error is a GraphQL error indicating a "429 Too Many Requests" scenario.
 *
 * In GraphQL, it's common for the HTTP response status to be 200 OK even when there are
 * application-level errors. This function helps identify "Too Many Requests" errors that
 * might be returned from a downstream service but are wrapped in a GraphQL response.
 *
 * @param error - The error object to inspect. It could be an ApolloErrorInterop or a generic error.
 * @returns {boolean} - Returns true if the error message contains an indication of a "429 Too Many Requests" error.
 */ const $211f773a291d5685$var$isGraphQLTooManyRequestsError = (error)=>{
    if (error && error.message) return error.message.includes('GraphQL error: [429 Too Many Requests]');
    return false;
};
module.exports["useHasBillingInformation"] = $211f773a291d5685$export$b4b101074ba9b8a2;

});

parcelRegister("f9jv7", function(module, exports) {

var $aMcHK = parcelRequire("aMcHK");

const $b29e4bf652226e80$export$6ccdb59d3479f4f1 = (error)=>(0, $aMcHK.isStatusCodeError)(error, '404');
module.exports["isNotFoundError"] = $b29e4bf652226e80$export$6ccdb59d3479f4f1;

});

parcelRegister("hY10E", function(module, exports) {
/**
 * @Relay no-runtime
 */ /**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $xQxzY = parcelRequire("xQxzY");


var $917iu = parcelRequire("917iu");


var $bQm3c = parcelRequire("bQm3c");


var $9wGTI = parcelRequire("9wGTI");


var $1ytiN = parcelRequire("1ytiN");


var $euL71 = parcelRequire("euL71");


var $kAcNG = parcelRequire("kAcNG");


var $a119A = parcelRequire("a119A");

const $8853af7e8236bde8$export$4695bad538a258b4 = ()=>{
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const isPremium = edition === (0, $euL71.ConfluenceEdition).PREMIUM;
    const { isSiteAdmin: isSiteAdmin } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    // SignUpProperties that are sent from BXP
    const { isReverseTrialer: isReverseTrialer, loading: loading, error: error } = $8853af7e8236bde8$export$153e1a2894ed595({
        skip: !isSiteAdmin || !isPremium
    });
    // Master FF to quickly enable / disable all Onboarding Experiences
    const isReverseTrialEligibleUser = isSiteAdmin && isPremium && (0, $9wGTI.fg)('cc_onboarding_experience');
    const isReverseTrialTreatmentCohort = !loading && !error && isReverseTrialer;
    return {
        isReverseTrialEligible: isReverseTrialEligibleUser && isReverseTrialTreatmentCohort
    };
};
function $8853af7e8236bde8$export$153e1a2894ed595({ skip: skip } = {}) {
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { data: reverseTrialData, loading: isReverseTrialLoading, error: reverseTrialError } = (0, $xQxzY.useQuery)((0, $eSUdr.default)`query useReverseTrialEligibleSignUpPropertiesQuery{signUpProperties{reverseTrial}}`, {
        skip: skip
    });
    const { loading: isSitePersonalizationLoading, error: sitePersonalizationError, attributes: attributes } = (0, $kAcNG.useSitePersonalizationQuery)({
        cloudId: cloudId,
        skip: skip
    });
    const TRIAL_PERIOD_DAYS = 45;
    let isWithinFirstTrialPeriod = true; // Default to true because if the activation date is not available, this means that the site was recently provisioned
    const activationDateAttr = attributes?.find((attr)=>attr.name === 'confluence.ondemand.activationDate');
    if (activationDateAttr && activationDateAttr.value) {
        const activationDate = new Date(activationDateAttr.value);
        const daysSinceActivation = (0, $917iu.default)(new Date(), activationDate);
        isWithinFirstTrialPeriod = daysSinceActivation <= TRIAL_PERIOD_DAYS;
    }
    const reverseTrialCohort = reverseTrialData?.signUpProperties?.reverseTrial;
    return {
        isReverseTrialer: isWithinFirstTrialPeriod && reverseTrialCohort === (0, $a119A.ReverseTrialCohort).ENROLLED,
        reverseTrialCohort: reverseTrialCohort,
        loading: skip ? false : isReverseTrialLoading || isSitePersonalizationLoading,
        error: skip ? null : reverseTrialError || sitePersonalizationError
    };
}
module.exports["useReverseTrialCohort"] = $8853af7e8236bde8$export$153e1a2894ed595;

});

parcelRegister("a119A", function(module, exports) {
/**
 * @generated SignedSource<<7c96ffe5db93bb7b8bc74d6411281d3b>>
 * This file was auto-generated by a codemod
 * @see https://go/connie-relay-migration-fyi
 **/ var $15e6aec9d603aba5$export$8798225e6f84b893 = /*#__PURE__*/ function(ReverseTrialCohort) {
    ReverseTrialCohort["CONTROL"] = "CONTROL";
    ReverseTrialCohort["ENROLLED"] = "ENROLLED";
    ReverseTrialCohort["NOT_ENROLLED"] = "NOT_ENROLLED";
    ReverseTrialCohort["UNASSIGNED"] = "UNASSIGNED";
    ReverseTrialCohort["UNKNOWN"] = "UNKNOWN";
    ReverseTrialCohort["VARIANT"] = "VARIANT";
    return ReverseTrialCohort;
}({});
module.exports["ReverseTrialCohort"] = $15e6aec9d603aba5$export$8798225e6f84b893;

});

parcelRegister("dhYWb", function(module, exports) {
const $9336b0b8d90394bf$export$7af15fb4b1ef8bf2 = 'auto_upgrade_not_a_trial';
const $9336b0b8d90394bf$export$31c76e063a58551f = 14;
const $9336b0b8d90394bf$export$e25ee5e8d56c9434 = 'auto-upgrade-avoid-deactivation-modal';
const $9336b0b8d90394bf$export$4c68c8f979e7c34e = 'autoUpgradeAvoidDeactivationModal';
const $9336b0b8d90394bf$export$e1dd560345bb2391 = 'autoUpgradeAvoidDeactivationBanner';
const $9336b0b8d90394bf$export$fb4037ac52e8f2af = 'auto-upgrade-avoid-deactivation-banner';
const $9336b0b8d90394bf$export$605e10c7fb710fe8 = 'auto-upgrade-avoid-deactivation-flag';
const $9336b0b8d90394bf$export$617971661581b89a = 'addPaymentAvoidDeactivation';
const $9336b0b8d90394bf$export$6b183dcf8256b901 = 'removeUsersAvoidDeactivation';
const $9336b0b8d90394bf$export$88ddc07ee0185a0 = 'autoUpgradeNotATrial';
const $9336b0b8d90394bf$export$4bdf96a244b85ff6 = 'autoUpgradeNotATrial';
const $9336b0b8d90394bf$export$6be2b9eb165d621f = 44;
const $9336b0b8d90394bf$export$51039dd19c9a3762 = {
    confluence: 10,
    'jira-product-discovery': 3,
    'jira-service-management': 3,
    jira: 10
};
const $9336b0b8d90394bf$export$466cbff150b55117 = {
    ['confluence']: 'user',
    ['jira']: 'user',
    ['jira-product-discovery']: 'creator',
    ['jira-service-management']: 'agent'
};
const $9336b0b8d90394bf$export$5a01ec5e3068630c = {
    ['confluence']: 'confluence',
    ['jira']: 'jira',
    ['jira-product-discovery']: 'jira',
    ['jira-service-management']: 'jira'
};
const $9336b0b8d90394bf$export$c17ca73287ae9119 = {
    ['confluence']: 'confluence',
    ['jira']: 'jira-software',
    ['jira-product-discovery']: 'jira-product-discovery',
    ['jira-service-management']: 'jira-servicedesk'
};
module.exports["AUNT_STATSIG_EXPERIMENT_KEY"] = $9336b0b8d90394bf$export$7af15fb4b1ef8bf2;
module.exports["STANDARD_TRIAL_DAYS_TO_DEACTIVATION"] = $9336b0b8d90394bf$export$31c76e063a58551f;
module.exports["AVOID_DEACTIVATION_MODAL_TEST_ID"] = $9336b0b8d90394bf$export$e25ee5e8d56c9434;
module.exports["AVOID_DEACTIVATION_MODAL_ACTION_SUBJECT_ID"] = $9336b0b8d90394bf$export$4c68c8f979e7c34e;
module.exports["AVOID_DEACTIVATION_BANNER_SUBJECT_ID"] = $9336b0b8d90394bf$export$e1dd560345bb2391;
module.exports["AVOID_DEACTIVATION_BANNER_TEST_ID"] = $9336b0b8d90394bf$export$fb4037ac52e8f2af;
module.exports["ADD_PAYMENT_AVOID_DEACTIVATION_ACTION_SUBJECT_ID"] = $9336b0b8d90394bf$export$617971661581b89a;
module.exports["REMOVE_USERS_AVOID_DEACTIVATION_ACTION_SUBJECT_ID"] = $9336b0b8d90394bf$export$6b183dcf8256b901;
module.exports["TAKE_ACTION_AVOID_DEACTIVATION_ACTION_SUBJECT_ID"] = $9336b0b8d90394bf$export$88ddc07ee0185a0;
module.exports["TAKE_ACTION_SOURCE_ID"] = $9336b0b8d90394bf$export$4bdf96a244b85ff6;
module.exports["MAX_USERS_ON_FREE_PLAN"] = $9336b0b8d90394bf$export$51039dd19c9a3762;
module.exports["PRODUCT_TO_CHARGE_ELEMENT"] = $9336b0b8d90394bf$export$466cbff150b55117;
module.exports["PRODUCT_TO_ORIGIN"] = $9336b0b8d90394bf$export$5a01ec5e3068630c;
module.exports["ProductKeyToHAMSMap"] = $9336b0b8d90394bf$export$c17ca73287ae9119;

});

parcelRegister("5EhYK", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $3pfAb = parcelRequire("3pfAb");


var $inPa6 = parcelRequire("inPa6");


var $8hmrm = parcelRequire("8hmrm");

var $gwZbZ = parcelRequire("gwZbZ");

var $6o7wX = parcelRequire("6o7wX");


var $dhYWb = parcelRequire("dhYWb");

const $b6e61a181e3b095b$export$85183a312807388d = (0, $3pfAb.FabricChannel).growth;
function $b6e61a181e3b095b$export$e955abb82869dc84() {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const sendAnalyticEvent = (0, $42omo.useCallback)((payload)=>{
        createAnalyticsEvent(payload).fire($b6e61a181e3b095b$export$85183a312807388d);
    }, [
        createAnalyticsEvent
    ]);
    const createAddPaymentsButtonClickEvent = (source, attributes)=>sendAnalyticEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: (0, $dhYWb.ADD_PAYMENT_AVOID_DEACTIVATION_ACTION_SUBJECT_ID),
            source: source,
            attributes: attributes
        });
    const createTakeActionClickEvent = (sourceId, attributes)=>sendAnalyticEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: (0, $dhYWb.TAKE_ACTION_AVOID_DEACTIVATION_ACTION_SUBJECT_ID),
            source: sourceId,
            attributes: attributes
        });
    const createRemoveUsersButtonClickEvent = (sourceId, attributes)=>sendAnalyticEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: (0, $dhYWb.REMOVE_USERS_AVOID_DEACTIVATION_ACTION_SUBJECT_ID),
            source: sourceId,
            attributes: attributes
        });
    const growthErrorHandler = ({ error: error, errorInfo: errorInfo, product: product, source: source })=>sendAnalyticEvent((0, $8hmrm.createProductSpecificAnalyticsIntegrationPayload)({
            team: (0, $6o7wX.Team).GROWTH_LUNA,
            product: product === 'confluence' ? (0, $gwZbZ.Product).CONFLUENCE : (0, $gwZbZ.Product).JIRA,
            experimentMeta: {
                experimentKey: (0, $dhYWb.AUNT_STATSIG_EXPERIMENT_KEY)
            },
            errorMessage: error.message,
            errorType: (0, $gwZbZ.ErrorType).GENERIC,
            source: source || (0, $dhYWb.AUNT_STATSIG_EXPERIMENT_KEY),
            severity: (0, $gwZbZ.Severity).HIGH,
            additionalAttributes: {
                ...errorInfo
            }
        }));
    return {
        sendAnalyticEvent: sendAnalyticEvent,
        createAddPaymentsButtonClickEvent: createAddPaymentsButtonClickEvent,
        createRemoveUsersButtonClickEvent: createRemoveUsersButtonClickEvent,
        createTakeActionClickEvent: createTakeActionClickEvent,
        growthErrorHandler: growthErrorHandler
    };
}
function $b6e61a181e3b095b$export$b901544a79a3bbad({ name: name, attributes: attributes }) {
    const { sendAnalyticEvent: sendAnalyticEvent } = $b6e61a181e3b095b$export$e955abb82869dc84();
    const hasSentScreenEvent = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        if (hasSentScreenEvent.current) return;
        sendAnalyticEvent({
            eventType: 'screen',
            name: name,
            attributes: attributes
        });
    }, [
        sendAnalyticEvent,
        name,
        attributes
    ]);
    return null;
}
module.exports["useAnalytics"] = $b6e61a181e3b095b$export$e955abb82869dc84;
module.exports["ScreenEvent"] = $b6e61a181e3b095b$export$b901544a79a3bbad;

});

parcelRegister("b0bCf", function(module, exports) {

var $dhYWb = parcelRequire("dhYWb");

const $e5eb9cf773a94bba$export$68b898ecc084962 = (product)=>{
    return {
        chargeElementSingular: (0, $dhYWb.PRODUCT_TO_CHARGE_ELEMENT)[product],
        chargeElementPlural: (0, $dhYWb.PRODUCT_TO_CHARGE_ELEMENT)[product] + 's'
    };
};
const $e5eb9cf773a94bba$export$291d012eb0744b34 = (product)=>{
    return (0, $dhYWb.ProductKeyToHAMSMap)[product];
};
const $e5eb9cf773a94bba$export$8e8e465e66e8e161 = (product)=>{
    switch(product){
        case 'jira':
            return 'Jira';
        case 'jira-service-management':
            return 'Jira Service Management';
        case 'jira-product-discovery':
            return 'Jira Product Discovery';
        case 'confluence':
            return 'Confluence';
        default:
            return '';
    }
};
module.exports["getChargeElementTypeByProduct"] = $e5eb9cf773a94bba$export$68b898ecc084962;
module.exports["getHamsKey"] = $e5eb9cf773a94bba$export$291d012eb0744b34;
module.exports["getProductNameFromProductKey"] = $e5eb9cf773a94bba$export$8e8e465e66e8e161;

});

parcelRegister("fAD9L", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $6xdDU = parcelRequire("6xdDU");


var $TSbNa = parcelRequire("TSbNa");

const $71b8fe84901d80f2$var$RenderModal = ({ modal: modal })=>{
    const [shouldCloseOnOverlayClick, setShouldCloseOnOverlayClick] = (0, $42omo.useState)();
    const [shouldCloseOnEscapePress, setShouldCloseOnEscapePress] = (0, $42omo.useState)();
    const Component = modal.component;
    return /*#__PURE__*/ (0, $l998X.jsx)(Component, {
        onClose: modal.close,
        shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
        shouldCloseOnEscapePress: shouldCloseOnEscapePress,
        setShouldCloseOnOverlayClick: setShouldCloseOnOverlayClick,
        setShouldCloseOnEscapePress: setShouldCloseOnEscapePress
    });
};
function $71b8fe84901d80f2$export$7c9538f5f3c365e9({ children: children }) {
    const id = (0, $42omo.useRef)(1);
    const [modals, setModals] = (0, $42omo.useState)([]);
    const modalContext = (0, $42omo.useMemo)(()=>({
            openModal: (component)=>{
                const key = String(id.current++);
                const close = ()=>{
                    setModals((mdls)=>mdls.filter((d)=>d.key !== key));
                };
                setModals((mdls)=>[
                        ...mdls,
                        {
                            close: close,
                            component: component,
                            key: key
                        }
                    ]);
            }
        }), []);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $TSbNa.ModalContext).Provider, {
        value: modalContext,
        children: [
            children,
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6xdDU.default), {
                children: modals.map((modal)=>/*#__PURE__*/ (0, $l998X.jsx)($71b8fe84901d80f2$var$RenderModal, {
                        modal: modal
                    }, modal.key))
            })
        ]
    });
}
module.exports["ModalContextProvider"] = $71b8fe84901d80f2$export$7c9538f5f3c365e9;

});

parcelRegister("TSbNa", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $645b684711965e78$export$ab57792b9b6974a6 = (0, $42omo.createContext)({
    openModal: ()=>{
        throw new Error("To show the modal, wrap your app's root component with a <ModalContextProvider />. import { ModalContextProvider } from '@atlassian/entry-point-modal-context/ModalContextProvider';");
    }
});
module.exports["ModalContext"] = $645b684711965e78$export$ab57792b9b6974a6;

});

parcelRegister("7wGk4", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $fBMbo = parcelRequire("fBMbo");


var $irOoi = parcelRequire("irOoi");


var $iP9n7 = parcelRequire("iP9n7");


var $cQDYl = parcelRequire("cQDYl");


var $8CZUH = parcelRequire("8CZUH");

var $1DHa6 = parcelRequire("1DHa6");

var $8o1lj = parcelRequire("8o1lj");

var $9ot3w = parcelRequire("9ot3w");

var $d8eRd = parcelRequire("d8eRd");


var $dh538 = parcelRequire("dh538");


var $eyWa4 = parcelRequire("eyWa4");


var $4M6GB = parcelRequire("4M6GB");


var $TSbNa = parcelRequire("TSbNa");


var $7wYo8 = parcelRequire("7wYo8");


var $48FEk = parcelRequire("48FEk");


var $gWF6I = parcelRequire("gWF6I");

const $abc57e0f1f470075$var$emptyEntryPointParams = {};
const $abc57e0f1f470075$var$emptyEntryPointProps = {};
function $abc57e0f1f470075$export$fb10b32cfe19f1e({ children: children, entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, Fallback: Fallback, title: title, modalProps: modalProps, forwardedRef: forwardedRef, onError: onError, preloadOnFocus: providedPreloadOnFocus }) {
    (0, $fBMbo.di)((0, $irOoi.loadEntryPoint));
    const { openModal: openModal } = (0, $42omo.useContext)((0, $TSbNa.ModalContext));
    const environmentProvider = (0, $gWF6I.useRelayEnvironmentProvider)();
    const { ModalErrorFallback: ModalErrorFallback } = (0, $4M6GB.useEntryPointConfig)();
    const preloadOnFocus = providedPreloadOnFocus ?? (0, $dh538.fg)('dst-a11y_preload-on-focus-default-true') ? true : false;
    const metricName = (0, $42omo.useMemo)(()=>{
        return entryPoint.root.getModuleName() || 'unknown';
    }, [
        entryPoint
    ]);
    const load = (0, $42omo.useCallback)(()=>(0, $irOoi.loadEntryPoint)(environmentProvider, entryPoint, entryPointParams ?? $abc57e0f1f470075$var$emptyEntryPointParams), [
        entryPoint,
        entryPointParams,
        environmentProvider
    ]);
    const onLoad = (0, $42omo.useCallback)(({ reference: entryPointReference, dispose: dispose })=>{
        openModal(({ onClose: closeModal, shouldCloseOnOverlayClick: shouldCloseOnOverlayClick, shouldCloseOnEscapePress: shouldCloseOnEscapePress, setShouldCloseOnOverlayClick: setShouldCloseOnOverlayClick, setShouldCloseOnEscapePress: setShouldCloseOnEscapePress })=>{
            const onClose = (extraInformation)=>{
                entryPointProps?.onClose?.(extraInformation);
                closeModal();
                dispose();
            };
            const defaultFallback = /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $9ot3w.default), {
                        children: title ? /*#__PURE__*/ (0, $l998X.jsx)((0, $d8eRd.default), {
                            children: title
                        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $eyWa4.default), {
                            grow: "fill",
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $cQDYl.default), {})
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $1DHa6.default), {
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $cQDYl.default), {}),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $cQDYl.default), {}),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $cQDYl.default), {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $8o1lj.default), {})
                ]
            });
            const container = /*#__PURE__*/ (0, $l998X.jsx)((0, $48FEk.InternalEntryPointContainer), {
                entryPointReference: entryPointReference,
                errorFallback: ({ error: error })=>/*#__PURE__*/ (0, $l998X.jsx)(ModalErrorFallback, {
                        error: error
                    }),
                onError: ({ error: error, errorInfo: errorInfo })=>{
                    onError?.({
                        error: error,
                        errorInfo: errorInfo
                    });
                    closeModal();
                },
                fallback: Fallback ? /*#__PURE__*/ (0, $l998X.jsx)(Fallback, {
                    onClose: closeModal
                }) : defaultFallback,
                id: metricName,
                placeholderName: "modal-entry-point-pressable-trigger-container",
                runtimeProps: {
                    ...entryPointProps ?? $abc57e0f1f470075$var$emptyEntryPointProps,
                    onClose: onClose,
                    setShouldCloseOnOverlayClick: setShouldCloseOnOverlayClick,
                    setShouldCloseOnEscapePress: setShouldCloseOnEscapePress,
                    shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
                    shouldCloseOnEscapePress: shouldCloseOnEscapePress
                }
            });
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $8CZUH.default), {
                ...modalProps,
                onClose: onClose,
                shouldCloseOnOverlayClick: shouldCloseOnOverlayClick ?? modalProps?.shouldCloseOnOverlayClick,
                shouldCloseOnEscapePress: shouldCloseOnEscapePress ?? modalProps?.shouldCloseOnEscapePress,
                children: container
            });
        });
    }, [
        openModal,
        title,
        modalProps,
        Fallback,
        metricName,
        entryPointProps,
        ModalErrorFallback,
        onError
    ]);
    const triggerRef = (0, $7wYo8.usePressablePreloadRef)({
        load: load,
        onLoad: onLoad,
        preloadOnFocus: preloadOnFocus
    });
    const mergedRef = (0, $iP9n7.useMergeRefs)([
        triggerRef,
        forwardedRef || null
    ]);
    return children({
        ref: mergedRef
    });
}
module.exports["ModalTrigger"] = $abc57e0f1f470075$export$fb10b32cfe19f1e;

});

parcelRegister("bJq0d", function(module, exports) {
var $cdac08834664f9ea$export$23e8f571dd61cd8c = /*#__PURE__*/ function(MPU_QUERY) {
    MPU_QUERY["HAMS_PRODUCT_KEY"] = "confluence.ondemand";
    MPU_QUERY["OFFERING_KEY"] = "2eda1119-fab4-4699-ab37-ff8f12052cde";
    return MPU_QUERY;
}({});
module.exports["MPU_QUERY"] = $cdac08834664f9ea$export$23e8f571dd61cd8c;

});


//# sourceMappingURL=TrialFlags.05c90837.js.map
